/**
 * Файл содержит функцию для скачивания выходных форм
 */
import {getFileNameFromContentDisposition} from "./ApiCommon";
import {downloadOutputFormFileById} from "../../OutputForms/Api";

/**
 * Функция для скачивания выходной формы
 * @param id - номер формы, по нему происходит
 * поиск соответствующей формы для скачивания
 */
export function onDownloadFileAction(id) {
    downloadOutputFormFileById(id).then(
        (res) => {
            const filename = getFileNameFromContentDisposition(res.headers['content-disposition'])
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        }
    )
}